<div class="app-container" *ngIf="isLoggedIn">
  <app-drawer>
    <app-header></app-header>
    <div class="router-content">
      <router-outlet></router-outlet>
    </div>
  </app-drawer>
</div>

<dx-toast
  [(type)]="toastType"
  [(message)]="toastmessage"
  [(visible)]="toastVisible"
  position="bottom right"
></dx-toast>
<app-login
  *ngIf="!isLoggedIn"
  (loginRedirect)="login()"
  (logout)="logout()"
></app-login>

<app-global-loader></app-global-loader>
<app-global-popup></app-global-popup>

<app-logging-popup> </app-logging-popup>

<app-file-viewer-overlay></app-file-viewer-overlay>
<!--
  Cookie banner disabled 2026-08-04. The app stores no analytics or tracking data — only the
  MSAL auth cache and first-party UI state, all covered by the "strictly necessary" exemption
  in § 25 (2) Nr. 2 TDDDG, which requires no consent. The banner also never gated anything:
  reject() wrote 'rejected' and every storage write ran anyway, and its text claimed usage
  analytics we do not perform. Disclosure is handled in the wiki (08-datenschutz) instead.
  Re-enable — and make it actually gate the writes — if analytics or any third-party SDK lands.
  The component itself was removed; recover it from git history.
-->
